import React, { useState, useEffect } from 'react';

type Props = {
    imageUrl?: string | null;
    onImageChange: (file: File | null) => void;
};

const ImageUploader: React.FC<Props> = ({ imageUrl, onImageChange }) => {
    const [, setSelectedImage] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(imageUrl || null);

    useEffect(() => {
        setPreviewUrl(imageUrl || null);
    }, [imageUrl]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0] || null;
        setSelectedImage(file);
        if (file) {
            setPreviewUrl(URL.createObjectURL(file));
        }
        onImageChange(file);
    };

    const removeImage = () => {
        setSelectedImage(null);
        setPreviewUrl(null);
        onImageChange(null);
    };

    return (
        <div className="image-uploader">
            {previewUrl ? (
                <div className="d-flex flex-column gap-2">
                    <div className="image-container">
                        <img
                            src={previewUrl}
                            alt="Client Logo"
                            className="preview-image"
                        />
                    </div>
                    <button onClick={removeImage}>Remove</button>
                </div>
            ) : (
                <div className='text-center'>
                    <input type="file" accept="image/*" onChange={handleFileChange} />
                </div>
            )}
        </div>
    );
};

export default ImageUploader;
